// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4eb42e2c","213":"52a48b59","239":"93a5f131","455":"e15bb6b4"}[chunkId] + ".chunk.js";
};